import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "ModalDelRegister",
  tabindex: "-1",
  "aria-labelledby": `ModalDelRegister`,
  "aria-hidden": "true",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header gap-4" }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<svg width=\"40\" height=\"40\" viewBox=\"0 0 40 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><rect width=\"40\" height=\"40\" rx=\"10\" fill=\"#F9F9F9\"></rect><g clip-path=\"url(#clip0_1141_1895)\"><path opacity=\"0.4\" d=\"M12.5 28.125C12.5 28.6223 12.6975 29.0992 13.0492 29.4508C13.4008 29.8025 13.8777 30 14.375 30H25.625C26.1223 30 26.5992 29.8025 26.9508 29.4508C27.3025 29.0992 27.5 28.6223 27.5 28.125V15H12.5V28.125ZM23.125 18.125C23.125 17.9592 23.1908 17.8003 23.3081 17.6831C23.4253 17.5659 23.5842 17.5 23.75 17.5C23.9158 17.5 24.0747 17.5659 24.1919 17.6831C24.3092 17.8003 24.375 17.9592 24.375 18.125V26.875C24.375 27.0408 24.3092 27.1997 24.1919 27.3169C24.0747 27.4342 23.9158 27.5 23.75 27.5C23.5842 27.5 23.4253 27.4342 23.3081 27.3169C23.1908 27.1997 23.125 27.0408 23.125 26.875V18.125ZM19.375 18.125C19.375 17.9592 19.4408 17.8003 19.5581 17.6831C19.6753 17.5659 19.8342 17.5 20 17.5C20.1658 17.5 20.3247 17.5659 20.4419 17.6831C20.5592 17.8003 20.625 17.9592 20.625 18.125V26.875C20.625 27.0408 20.5592 27.1997 20.4419 27.3169C20.3247 27.4342 20.1658 27.5 20 27.5C19.8342 27.5 19.6753 27.4342 19.5581 27.3169C19.4408 27.1997 19.375 27.0408 19.375 26.875V18.125ZM15.625 18.125C15.625 17.9592 15.6908 17.8003 15.8081 17.6831C15.9253 17.5659 16.0842 17.5 16.25 17.5C16.4158 17.5 16.5747 17.5659 16.6919 17.6831C16.8092 17.8003 16.875 17.9592 16.875 18.125V26.875C16.875 27.0408 16.8092 27.1997 16.6919 27.3169C16.5747 27.4342 16.4158 27.5 16.25 27.5C16.0842 27.5 15.9253 27.4342 15.8081 27.3169C15.6908 27.1997 15.625 27.0408 15.625 26.875V18.125ZM28.125 11.25H23.4375L23.0703 10.5195C22.9925 10.3634 22.8727 10.232 22.7243 10.1402C22.576 10.0484 22.4049 9.99988 22.2305 10H17.7656C17.5916 9.99934 17.4208 10.0477 17.273 10.1396C17.1251 10.2315 17.0062 10.3632 16.9297 10.5195L16.5625 11.25H11.875C11.7092 11.25 11.5503 11.3159 11.4331 11.4331C11.3158 11.5503 11.25 11.7092 11.25 11.875V13.125C11.25 13.2908 11.3158 13.4497 11.4331 13.5669C11.5503 13.6842 11.7092 13.75 11.875 13.75H28.125C28.2908 13.75 28.4497 13.6842 28.5669 13.5669C28.6842 13.4497 28.75 13.2908 28.75 13.125V11.875C28.75 11.7092 28.6842 11.5503 28.5669 11.4331C28.4497 11.3159 28.2908 11.25 28.125 11.25Z\" fill=\"#203972\"></path><path d=\"M28.125 11.25H23.4375L23.0703 10.5195C22.9925 10.3634 22.8727 10.232 22.7243 10.1402C22.576 10.0484 22.4049 9.99988 22.2305 10H17.7656C17.5916 9.99934 17.4208 10.0477 17.273 10.1396C17.1251 10.2315 17.0062 10.3632 16.9297 10.5195L16.5625 11.25H11.875C11.7092 11.25 11.5503 11.3159 11.4331 11.4331C11.3158 11.5503 11.25 11.7092 11.25 11.875V13.125C11.25 13.2908 11.3158 13.4497 11.4331 13.5669C11.5503 13.6842 11.7092 13.75 11.875 13.75H28.125C28.2908 13.75 28.4497 13.6842 28.5669 13.5669C28.6842 13.4497 28.75 13.2908 28.75 13.125V11.875C28.75 11.7092 28.6842 11.5503 28.5669 11.4331C28.4497 11.3159 28.2908 11.25 28.125 11.25Z\" fill=\"#203972\"></path></g><defs><clipPath id=\"clip0_1141_1895\"><rect width=\"20\" height=\"20\" fill=\"white\" transform=\"translate(10 10)\"></rect></clipPath></defs></svg>", 1)
const _hoisted_6 = {
  class: "modal-title",
  id: "ModalDelRegisterLabel",
  style: {"color":"var(--cor_texto_1)","margin-right":"auto"}
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  "data-bs-dismiss": "modal",
  "aria-label": "Close",
  style: {"background-color":"transparent","border":"none"}
}, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "18",
    height: "18",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M12.6641 9L17.5503 4.11377C18.1499 3.51416 18.1499 2.54199 17.5503 1.94189L16.4644 0.855957C15.8647 0.256348 14.8926 0.256348 14.2925 0.855957L9.40625 5.74219L4.52002 0.855957C3.92041 0.256348 2.94824 0.256348 2.34814 0.855957L1.26221 1.94189C0.662598 2.5415 0.662598 3.51367 1.26221 4.11377L6.14844 9L1.26221 13.8862C0.662598 14.4858 0.662598 15.458 1.26221 16.0581L2.34814 17.144C2.94775 17.7437 3.92041 17.7437 4.52002 17.144L9.40625 12.2578L14.2925 17.144C14.8921 17.7437 15.8647 17.7437 16.4644 17.144L17.5503 16.0581C18.1499 15.4585 18.1499 14.4863 17.5503 13.8862L12.6641 9Z",
      fill: "#B5B5C3"
    })
  ])
], -1)
const _hoisted_8 = { class: "modal-body" }
const _hoisted_9 = { style: {"color":"var(--cor_texto_1)"} }
const _hoisted_10 = { class: "modal-footer gap-4" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn background_btn_1_opct m-0",
  "data-bs-dismiss": "modal"
}, "Cancelar", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-trash-alt",
  "aria-hidden": "true",
  style: {"color":"var(--cor_icones_1)"}
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("h5", _hoisted_6, _toDisplayString(_ctx.header), 1),
          _hoisted_7
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("p", _hoisted_9, [
            _createTextVNode(_toDisplayString(_ctx.message) + " " + _toDisplayString(_ctx.question) + " ", 1),
            _createElementVNode("strong", null, _toDisplayString(_ctx.name), 1),
            _createTextVNode("? ")
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("button", {
            type: "button",
            "data-bs-dismiss": "modal",
            style: {"color":"var(--cor_icones_1)"},
            "aria-label": "Close",
            class: "btn background_btn_1 m-0",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleButtonClick && _ctx.handleButtonClick(...args)))
          }, [
            _hoisted_12,
            _createTextVNode(" Excluir ")
          ])
        ])
      ])
    ])
  ]))
}